<a
  class="sm-policy-link__content"
  [attr.href]="isClickable ? href : null"
  [attr.aria-label]="isClickable ? ariaLabel || null : null"
  (click)="handleClick($event)">
  <ng-content></ng-content>
</a>
